import { render, staticRenderFns } from "./BranchInventories.vue?vue&type=template&id=31d31ccc&scoped=true"
import script from "./BranchInventories.vue?vue&type=script&lang=js"
export * from "./BranchInventories.vue?vue&type=script&lang=js"
import style0 from "./BranchInventories.vue?vue&type=style&index=0&id=31d31ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d31ccc",
  null
  
)

export default component.exports